import { render, staticRenderFns } from "./icon.html?vue&type=template&id=785d5cc8&scoped=true&"
import script from "./icon.js?vue&type=script&lang=js&"
export * from "./icon.js?vue&type=script&lang=js&"
import style0 from "./icon.scss?vue&type=style&index=0&id=785d5cc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785d5cc8",
  null
  
)

export default component.exports